type StorageFacilityLike = { name: string; archivedAt?: string | null };

export const isStorageFacilityArchived = (facility: StorageFacilityLike): boolean => facility.archivedAt != null;

/** The facility's name, marked when archived so a filter or lookup that still shows it says so. */
export const storageFacilityLabel = (facility: StorageFacilityLike): string =>
  isStorageFacilityArchived(facility) ? `${facility.name} (archived)` : facility.name;
